<template>
<div>
    <!-- modal -->
    <b-modal id="jobUpdateDetailFormModal" centered size="lg" no-close-on-backdrop ref="jobUpdateDetailFormModal" :title=" $t('jobUpdateDetail.info')" :cancel-title=" $t('others.cancel_title')" :ok-title=" $t('others.ok_title')" cancel-variant="outline-secondary" @ok.prevent="addOrUpdate">
        <b-form>
            <b-row>
                <b-col class="col-lg-6">
                    <validation-provider :name="$t('jobUpdateDetail.employee')" :rules="{ excluded: 0 }" v-slot="{ errors }">
                        <label for="ledes-type-input">{{ $t('jobUpdateDetail.employee') }}</label>
                        <b-form-select size="sm" :state="errors.length > 0 ? false : null" v-model="employeeSelect" value-field="id" text-field="name" :options="employeeOption" />
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </b-col>
                <b-col class="col-lg-6">
                    <b-form>
                        <label for="job-update-detail-next-job-deadline-input">{{ $t('jobUpdateDetail.next_job_deadline') }}</label>
                        <CustomDatePicker :datePickerValidateOption="0" v-model="nextJobDeadline"  @input="checkDateWeekendOrHoliday()"></CustomDatePicker>
                    </b-form>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="col-lg-6">
                    <b-form>
                        <label for="job-update-detail-tpmk-deadline-input">{{ $t('jobUpdateDetail.tpmk_deadline') }}</label>
                        <CustomDatePicker :datePickerValidateOption="(roleId == 1 || this.employeeId == 115)?0:2" v-model="tpmkDeadline"></CustomDatePicker>
                    </b-form>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="col-lg-12">
                    <b-form-group> 
                        <label for="job-note-input">{{ $t('jobUpdateDetail.note') }}</label>
                        <b-form-textarea id="job-note-input" maxlength="1000" :placeholder=" $t('jobUpdateDetail.note')" v-model="note" rows="3" />
                    </b-form-group>
                </b-col>
            </b-row>
        </b-form>
    </b-modal>
</div>
</template>

<script>
export default {
    props: {
        getJobDetailList: {
            type: Function
        },
        getJobReportList: {
            type: Function
        },
        recordId: {
            type: Number
        },
    },
    data() {
        return {
            id: 0,
            note: '',
            jobId: 0,
            employeeSelect: 0,
            employeeOption: [],
            nextJobDeadline: null,
            tpmkDeadline: null,
            roleId:0,
            employeeId:0
        }
    },
    methods: {
        checkDateWeekendOrHoliday() {
            const data = {
                date: this.nextJobDeadline
            }

            const controller = {
                name: 'Common',
                actionName: 'CheckDateWeekendOrHoliday'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if(response.data.resultMessage != null)
                {
                    this.$CustomAlert(this.$t("alerts.the_date_you_choose_falls_on_a_holiday"), "warning")
                }                
            })
        },
        showInfo(id, jobId) {
            this.employeeId = localStorage.getItem("EmployeeId")
            this.roleId = localStorage.getItem('RoleId')
            this.$refs['jobUpdateDetailFormModal'].show()
            this.id = id
            this.jobId = jobId
            const data = {
                id: this.id,
                jobId: jobId
            }
            const controller = {
                name: 'JobHistory'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/getInfo', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.note = response.data.jobHistoryDto.note
                    this.employeeOption = response.data.employeeList
                    if (this.employeeOption !== null) {
                        this.employeeOption.splice(0, 0, this.$nullSelected())
                    }
                    if (response.data.jobHistoryDto.employeeId > 0) {
                        this.employeeSelect = response.data.jobHistoryDto.employeeId
                    }
                    this.nextJobDeadline = response.data.jobHistoryDto.nextJobDeadline
                    this.tpmkDeadline = response.data.jobHistoryDto.tpmkDeadline                    
                } else {
                    this.$bvModal.hide('jobUpdateDetailFormModal')
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
        addOrUpdate() {
            const data = {
                jobHistoryId: this.id,
                note: this.note,
                nextJobDeadline: this.nextJobDeadline,
                tpmkDeadline: this.tpmkDeadline,                
                employeeId: this.employeeSelect
            }
            const controller = {
                name: 'JobHistory',
                actionName: 'UpdateJobHistory'

            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {

                    if (this.getJobDetailList != null)
                        this.getJobDetailList(this.jobId)

                    if (this.getJobReportList != null)
                        this.getJobReportList()

                    this.$bvModal.hide('jobUpdateDetailFormModal')
                    this.$SaveAlert()
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
    }
}
</script>

<style lang="scss">
[dir=ltr] .modal-header .close {
    margin: -0.4rem -0.4rem -0.8rem auto;
}

[dir] label {
    margin-bottom: 0.2857rem;
    font-weight: bold;
}

.modal .modal-content {
    overflow: visible;
    margin-bottom: auto;
}

[dir] .invalid-tooltip {
    padding: 0.4rem 0.775rem !important;
    margin-top: -1.5rem !important;
    background-color: #ea5455 !important;
    border-radius: 0.358rem !important;
    left: 20px !important
}
</style>
